async function blobToFile(image, name = 'default', type){
  return new Promise(function(resolve, reject){
    fetch(image)
      .then(r => r.blob())
      .then(blobFile => resolve(new File([blobFile], name, {type})))
      .catch(err => reject(err))
  })
}

export { blobToFile }
